import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
// import { ClienteAnaliseMercadoCreateSharedModule } from '../create';
import { ClienteAnaliseMercadoPerspectivaProjetadaModule } from '../projetada';
import { ClienteCarteiraPreBaixarModule } from '../../../cliente-carteira/prebaixar';
import { ClienteCarteiraBaixarModule } from '../../../cliente-carteira/baixar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { ClienteAnaliseMercadoPerspectivaMetaComponent } from './cliente-analise-mercado-perspectiva-meta.component';

@NgModule({
    imports: [
        SharedModule,
        // ClienteAnaliseMercadoCreateSharedModule,
        ClienteAnaliseMercadoPerspectivaProjetadaModule,
        ClienteCarteiraPreBaixarModule,
        ClienteCarteiraBaixarModule,
        DragDropModule,
        CdkScrollableModule,
        ScrollingModule,
        InfiniteScrollModule
    ],
    declarations: [
        ClienteAnaliseMercadoPerspectivaMetaComponent
    ],
    exports: [
        ClienteAnaliseMercadoPerspectivaMetaComponent
    ],
    providers: [ ]
})
export class ClienteAnaliseMercadoPerspectivaMetaModule { }
